import { CATALOG_SECTIONS, EQUIPAMIENTO, FUSION, MARK_LIST, MOBILE_PREPAID, OTHERS, TRIO, EMAILMPLUS_FAKE_REGEX, PO_CATEGORY_TELEVISION } from "@/constants/constants";
import LocalStorageLib from "@gcloud-npm/utils.secure.local-storage";

export const deepCopy = (obj, visited = new WeakMap()) => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }
  if (visited.has(obj)) {
    return visited.get(obj);
  }
  const newObj = Array.isArray(obj) ? [] : {};
  visited.set(obj, newObj);
  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[key] = deepCopy(obj[key], visited);
    }
  }
  return newObj;
};

export const getTotalDaysBetween = (startDate, endDate) => {
  const diffTime = endDate.getTime() - startDate.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
  return diffDays + 1;
}

export const getToday = () => {
  const today = new Date();
  return {
    year: today.getFullYear(),
    month: today.getMonth() + 1,
    day: today.getDate(),
  };
};

export const formatDateUsagesToDetailProduct = (stringDate) => {
  const parts = stringDate.split('-');
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);
  const formattedDate = new Date(year, month, day).toLocaleDateString('es-ES', { month: 'long', day: 'numeric' });
  return formattedDate;
};
export const parseError = (stringResp) => {
  try {
    return { obj: JSON.parse(stringResp), parseState: true };
  } catch (err) {
    return { obj: stringResp, parseState: false };
  }
};

const newAPCheck = (hiredProducts) => {
  if (!hiredProducts || !Array.isArray(hiredProducts) || hiredProducts.length === 0) {
    return false;
  }
  for (const product of hiredProducts) {
    const { productType, subseccion, categorias, productOfferingCategory } = product;
    if (productType === FUSION || productType === TRIO || productType === MOBILE_PREPAID) {
      return false;
    } if (productType === OTHERS) {
      if (subseccion !== '388'
        || productOfferingCategory === PO_CATEGORY_TELEVISION) {
        return false;
      } if (categorias && categorias.tipoDispositivo !== null) {
        return false;
      }
    }
  }
  return true;
};

export const getMarkNewAP = (hiredProducts, persistedInfo) => {
  const markList = persistedInfo && persistedInfo.userPq && persistedInfo.userPq.ml && persistedInfo.userPq.ml;
  let nAP = false;
  if (markList && Array.isArray(markList) && markList.length > 0 && markList.includes(MARK_LIST.nuevoAP)) {
    nAP = true
  } else if (!markList) {
    nAP = newAPCheck(hiredProducts);
  };
  return nAP;
}

export const getProductTvFromHiredProducts = ({
  products,
}) => {
  let tvProductsMovistarPlus=[];
  const tvProducts = products.filter(
    (x) => x.tv !== null
  );
  tvProducts.map(x=>tvProductsMovistarPlus.push(x.tv));
  return tvProductsMovistarPlus;
};

export const checkFakeEmail = (email) => {
  let isFake = false;
  const pattern2 = '@movistar.es';
  const pattern3 = 'notiene@';
  const pattern4 = '@telefonica.es';
  const pattern5 = 'ñ';

  if (
    email
    && (
      EMAILMPLUS_FAKE_REGEX.test(email)
      || email.indexOf(pattern2) !== -1
      || email.indexOf(pattern3) !== -1
      || email.indexOf(pattern4) !== -1
      || email.indexOf(pattern5) !== -1
    )
  ) {
    isFake = true;
  }

  return isFake;
}

export const obtenerFechasCicloFacturacion = () => {
  // Obtiene la fecha actual
  const fechaActual = new Date();
  const diaInicio = 18;
  const diaFin = 17;

  // Obtiene el año y el mes actual
  const añoActual = fechaActual.getFullYear();
  const mesActual = fechaActual.getMonth() + 1; // Los meses van de 0 a 11, por eso se suma 1

  // Determina el mes de inicio y fin del ciclo de facturación
  let mesInicio, mesFin, añoInicio, añoFin;
  if (fechaActual.getDate() < diaInicio) {
    // Si la fecha actual es menor que el día de inicio, el mes de inicio es el mes anterior
    mesInicio = mesActual === 1 ? 12 : mesActual - 1;
    mesFin = mesActual;
    añoInicio = mesActual === 1 ? añoActual - 1 : añoActual;
    añoFin = añoActual;
  } else {
    // Si la fecha actual es igual o mayor que el día de inicio, el mes de inicio es el mes actual
    mesInicio = mesActual;
    mesFin = mesActual === 12 ? 1 : mesActual + 1;
    añoInicio = añoActual;
    añoFin = mesActual === 12 ? añoActual + 1 : añoActual;
  }

  // Define las fechas de inicio y fin del ciclo de facturación
  const dateStartCycleBilling = new Date(añoInicio, mesInicio - 1, diaInicio);
  const dateEndCycleBilling = new Date(añoFin, mesFin - 1, diaFin);

  // Formatea las fechas para la salida
  const formatoInicio = `${diaInicio}-${mesInicio < 10 ? '0' + mesInicio : mesInicio}-${añoInicio}`;
  const formatoFin = `${diaFin}-${mesFin < 10 ? '0' + mesFin : mesFin}-${añoFin}`;

  // Calcula los días restantes hasta el final del ciclo de facturación
  const milisegundosPorDia = 1000 * 60 * 60 * 24; // Cantidad de milisegundos en un día
  const tiempoRestante = dateEndCycleBilling - fechaActual;
  const remainingDays = Math.ceil(tiempoRestante / milisegundosPorDia);

  return {
    dateStartCycleBilling: formatoInicio,
    dateEndCycleBilling: formatoFin,
    remainingDays,
  };
};

export const getYear = (stringDate) => {
  const date = new Date(stringDate);
  return date.getFullYear().toString();
};

export const getMonthNumber = (stringDate) => {
  const date = new Date(stringDate);
  return (date.getMonth() + 1).toString().padStart(2, '0');
};

export const getDay = (stringDate) => {
  const date = new Date(stringDate);
  return date.getDate().toString().padStart(2, '0');
};

export const changeServerFormatToFrontFormat = dateString => {
  if (dateString) {
    const [datePart, timePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-');
    // const [hours, minutes, seconds] = timePart.split(':');
  
    return `${day}/${month}/${year}`;
  }
  return '';
};

export const dateToHHMMutc = (stringDate) => {
  if (!stringDate) {
    return '';
  }
  const date = new Date(stringDate);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
};
export const changeTelcoFormatToFrontFormat = (dateString) => {
  let fechaFormateada = '';
  if (dateString) {
    const fechaFin = new Date(dateString);

    const dia = fechaFin.getDate();
    const mes = fechaFin.getMonth() + 1; // Agregamos 1 porque los meses van de 0 a 11
    const año = fechaFin.getFullYear();

    fechaFormateada = `${dia < 10 ? '0' + dia : dia}-${mes < 10 ? '0' + mes : mes}-${año}`;
  }
  return fechaFormateada;
}

export const isSmartWifiCompatible = ({ smartWiFiDevices, line}) => {
  if (smartWiFiDevices && line && smartWiFiDevices[line]?.devices) {
    return true
  } else {
    return false
  }
}

export const isSmartWifiActivateable = ({ smartWiFiOthersDetails }) => {
  if (smartWiFiOthersDetails && smartWiFiOthersDetails.smartWifiDetalleWifi && Array.isArray(smartWiFiOthersDetails.smartWifiDetalleWifi) && smartWiFiOthersDetails.smartWifiDetalleWifi.length > 0) {
    return true
  } else {
    return false
  }
}

export const getTaggingInfoObj = ({
  textGa,
  buttonState,
  gestion_sistema,
  gestion_paso,
  addButtonState = false,
}) => {
  let gestionDetailText = "";
  if (addButtonState) {
    gestionDetailText = `${textGa}-${buttonState ? "desactivar" : "activar"}`;
  } else {
    gestionDetailText = `${textGa}`;
  }
  return {
    gestion_paso: gestion_paso,
    gestion_sistema: gestion_sistema,
    gestion_detalle: gestionDetailText,
  };
};
export const getTaggingConfigObj = ({eventType}) => {
  return { eventType: eventType };
};

export const accessPropertyByDotNotation = (obj, dotNotationString) => {
  const dotNotationStringParts = dotNotationString.split('.');
  let objectToReturn = { ...obj };
  for (let i = 0; i < dotNotationStringParts.length; i += 1) {
    const pathSegment = dotNotationStringParts[i];

    if (objectToReturn[pathSegment]) {
      objectToReturn = objectToReturn[pathSegment];
    } else {
      objectToReturn = null;
      break;
    }
  }

  return objectToReturn;
}

export const hasSecureEsimPending = () => {
  let hasSecureEsimPending=false;
  const localStorageLib = new LocalStorageLib();
  const secure = localStorageLib.getItem("ts"); // Aqui ya tienes el Secure entero
  if (secure && secure?.customer && secure?.customer?.campaigns && secure?.customer?.campaigns?.redeemed) {
    const campaigns = secure.customer.campaigns.redeemed;
    const campaignMatch=campaigns.find(x=> x?.campaignId === "eSim_activacion_pendiente")
    if(campaignMatch){
      hasSecureEsimPending=true
    }
  }
  return hasSecureEsimPending;
};

export const changeToBold = (text) => {
  const words = ["activado", "contratado"];
  if (text) {
    const regex = new RegExp(`\\b(${words.join('|')})\\b`, 'gi');
    const newText = text.replace(regex, '<strong>$1</strong>');
    return newText;
  }
}

export const isExternalUrl = (url = '', forceExternal = false) => {
  return !!(forceExternal || (url && url.startsWith('http')));
};

export const isObjectAndNotEmpty = (obj) => {
  return typeof obj === 'object' && obj !== null && Object.keys(obj).length > 0;
}
